import React from "react";
import { Button, ButtonGroup } from "aible";

import Select from "react-select";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";

import Tooltip from "components/Inputs/Tooltip";

import downloadFeedbackIcon from "images/file-arrow-down-light.svg";

import SimplePieChart from "components/LanguageModelArtifact/SimplePieChart";
import SimpleBarChart from "components/ChatAnalytics/SimpleBarChart";
import SimpleLineChart from "components/ChatAnalytics/SimpleLineChart";
import WordCountChart from "components/LanguageModelArtifact/WordCountChart";

import * as chatGPTReducer from "containers/ChatGPT/reducer";

// import WordCloud from "react-d3-cloud"; bring back if needed
import moment from "moment";

import styles from "./style.module.css";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

export default class ChatAnalytics extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOverview: false,
      chat_type: "OVERVIEW",
      anomaly_modal: undefined,
      loading_state: 0,
      feedback_type: "ALL"
    };

    setTimeout(() => this.mockLoading(), 5000);
  }

  mockLoading() {
    const { loading_state } = this.state;

    this.setState({ loading_state: loading_state + 1 });

    return setTimeout(() => this.mockLoading(), 5000);
  }

  countWordOccurrences(text) {
    // Remove any punctuation and convert the text to lowercase
    const cleanedText = text.replace(/[^\w\s]|_/g, "").toLowerCase();

    // Split the cleaned text into an array of words
    const words = cleanedText.split(" ");

    // Create an array to store word occurrences
    const wordOccurrences = [];

    const WORD_WEIGHT = words.length < 100 ? 500 : words.length < 500 ? 100 : 50;

    // Iterate over each word
    for (let i = 0; i < words.length; i++) {
      const word = words[i];

      // Find the word object in the array
      const wordObject = wordOccurrences.find((obj) => obj.text === word);

      if (wordObject) {
        // If the word object exists, increment its count
        wordObject.value += WORD_WEIGHT;
      } else {
        // Otherwise, add a new word object with a count of 1
        wordOccurrences.push({ text: word, value: 1 });
      }
    }

    return wordOccurrences;
  }

  renderWordFeedbackCount() {
    const { allChats } = this.props;

    const fChats = allChats.filter((a) => a?.feedback?.THUMBS_UP?.length > 0 || a?.feedback?.THUMBS_DOWN?.length > 0);

    return (
      <div
        className={styles.chatInfoTile}
        style={{
          width: "max(450px, 25%)"
        }}
      >
        <div className={styles.chartTitle}>{"Word Count and Feedback: "}</div>
        <div className={styles.feedbackBarChart}>
          <WordCountChart feedback={fChats} />
        </div>
      </div>
    );
  }

  renderAnomalyModal() {
    const { anomaly_modal } = this.state;

    return (
      <Dialog open={anomaly_modal !== undefined} opOpenChanges={() => this.setState({ anomaly_modal: undefined })}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{"Anomalous Prompt by " + anomaly_modal?.[0]?.analytics?.user}</DialogTitle>
          </DialogHeader>
          <div>{"Prompts: "}</div>
          <div>
            {anomaly_modal &&
              anomaly_modal.map((message) => {
                const retText = message?.userText ?? message?.text;

                return <div>{retText}</div>;
              })}
          </div>
        </DialogContent>
      </Dialog>
    );
  }

  renderPromptWarnings() {
    const anomalies_users = this.getAnomaliesByUser();

    return (
      <div className={styles.promptWarnings}>
        <div className={styles.pTitle}>{"Anomalous Prompt Warnings"}</div>
        <div className={styles.pList}>
          {Object.keys(anomalies_users).map((p) => {
            const pList = anomalies_users[p];
            let my_datasets = {};

            pList.forEach((convo) => {
              const dKey = convo?.analytics?.datasetId ?? "None";

              if (my_datasets[dKey] === undefined) {
                my_datasets[dKey] = [];
              }

              my_datasets[dKey].push(convo);
            });

            return (
              <div
                className={styles.pItem}
                onClick={() =>
                  this.setState({
                    anomaly_modal: pList
                  })
                }
              >
                <div className={styles.pItemTop}>{pList.length + " Prompts by " + pList?.[0]?.analytics?.user}</div>
                <div className={styles.pItemMid}>
                  {Object.keys(my_datasets).length +
                    " Dataset" +
                    (Object.keys(my_datasets).length === 1 ? "" : "s") +
                    ": " +
                    Object.keys(my_datasets).reduce((a, b) => b + ", " + a, "")}
                </div>
                <div className={styles.pItemBot}>
                  {anomalies_users[p]?.[0]?.date !== undefined
                    ? moment.utc(anomalies_users[p]?.[0]?.date).local().fromNow()
                    : anomalies_users[p]?.[0]?.date}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  renderOverview() {
    const {
      users,
      allChats,
      isLoadingChatAnalytics,
      filter_model_option,
      filter_qa_option,
      filter_use_option,
      updateFilterModel,
      updateFilterQA,
      updateFilterUseCase,
      chatBlueprints,
      modelOptions,
      reports
    } = this.props;
    const { chat_type, loading_state } = this.state;

    const posCount = allChats ? allChats.filter((a) => a?.feedback?.THUMBS_UP?.length > 0).length : 0;
    const negCount = allChats ? allChats.filter((a) => a?.feedback?.THUMBS_DOWN?.length > 0).length : 0;

    const totalInteractions = allChats ? allChats.length : "...";

    let retModelOptions = [{ label: "All", value: "All" }];
    modelOptions &&
      modelOptions.forEach((c) => {
        retModelOptions.push({ label: c.label, value: c.value });
      });

    const qaOptions = [
      { label: "Questions Only", value: "Questions Only" },
      { label: "Answers Only", value: "Answers Only" },
      { label: "Questions and Answers", value: "Questions and Answers" }
    ];

    let useCaseOptions = [{ label: "All", value: "All" }];
    chatBlueprints &&
      chatBlueprints.forEach((c) => {
        useCaseOptions.push({ label: c.name, value: c.id });
      });

    return isLoadingChatAnalytics === true ? (
      <div className={styles.chatLoading}>
        <div className={styles.loadingHeader}>{"Loading Chat Analytics"}</div>
        <div>{"This will take longer for folders with a lot of projects."}</div>
        <div className={styles.loadingItem}>
          {loading_state === 0 ? (
            <LoadingIndicator style={{ margin: "0px", transform: "scale(0.5" }} />
          ) : (
            <FontAwesomeIcon className={styles.loadIcon} icon={faCheckCircle} />
          )}
          <div className={styles.loadingText}>{"Evaluating all data and documents added"}</div>
        </div>
        <div className={styles.loadingItem}>
          {loading_state === 1 ? (
            <LoadingIndicator style={{ margin: "0px", transform: "scale(0.5" }} />
          ) : loading_state < 1 ? (
            <div className={styles.loadIconCircle} />
          ) : (
            <FontAwesomeIcon className={styles.loadIcon} icon={faCheckCircle} />
          )}
          <div className={styles.loadingText}>{"Evaluating all chat activity"}</div>
        </div>
        <div className={styles.loadingItem}>
          {loading_state === 2 ? (
            <LoadingIndicator style={{ margin: "0px", transform: "scale(0.5" }} />
          ) : loading_state < 2 ? (
            <div className={styles.loadIconCircle} />
          ) : (
            <FontAwesomeIcon className={styles.loadIcon} icon={faCheckCircle} />
          )}
          <div className={styles.loadingText}>{"Compiling model feedback"}</div>
        </div>
        <div className={styles.loadingItem}>
          {loading_state >= 3 ? (
            <LoadingIndicator style={{ margin: "0px", transform: "scale(0.5" }} />
          ) : loading_state < 3 ? (
            <div className={styles.loadIconCircle} />
          ) : (
            <FontAwesomeIcon className={styles.loadIcon} icon={faCheckCircle} />
          )}
          <div className={styles.loadingText}>{"Generating report"}</div>
        </div>
      </div>
    ) : (
      <React.Fragment>
        <div>
          <div className={styles.topActions}>
            <div className={styles.topTitle} style={{ marginRight: "40px" }}>
              {"Chat Logging, Monitoring, and Anomaly Detection"}
            </div>
            <ButtonGroup>
              <Button onClick={() => this.setState({ chat_type: "OVERVIEW" })} active={chat_type === "OVERVIEW"}>
                {"Overview"}
              </Button>
              <Button
                onClick={() => this.setState({ chat_type: "ACTIVITY_MONITORING" })}
                active={chat_type === "ACTIVITY_MONITORING"}
              >
                {"Activity Monitoring"}
              </Button>
              <Button
                onClick={() => this.setState({ chat_type: "FEEDBACK_ANALYTICS" })}
                active={chat_type === "FEEDBACK_ANALYTICS"}
              >
                {"Feedback Analytics Monitoring"}
              </Button>
              <Button
                onClick={() => this.setState({ chat_type: "ANOMALY_ALERTS" })}
                active={chat_type === "ANOMALY_ALERTS"}
              >
                {"Anomaly Alerts"}
              </Button>
              <Button
                onClick={() => this.setState({ chat_type: "CACHED_PROMPTS" })}
                active={chat_type === "CACHED_PROMPTS"}
              >
                {"Cached Prompts"}
              </Button>
            </ButtonGroup>
            <div className={styles.topActionSelect}>
              <Select
                placeholder="All Models"
                options={retModelOptions}
                value={retModelOptions?.find((f) => f.value === filter_model_option)}
                onChange={(val) => updateFilterModel(val.value)}
              />
            </div>
            <div className={styles.topActionSelect}>
              <Select
                placeholder="Questions and Answers"
                options={qaOptions}
                value={qaOptions?.find((f) => f.value === filter_qa_option)}
                onChange={(val) => updateFilterQA(val.value)}
              />
            </div>
            <div className={styles.topActionSelect}>
              <Select
                placeholder="All Agent Templates"
                options={useCaseOptions}
                value={useCaseOptions?.find((f) => f.value === filter_use_option)}
                onChange={(val) => updateFilterUseCase(val.value)}
              />
            </div>
          </div>
          {chat_type === "OVERVIEW" ? (
            <div className={styles.aMid}>
              <div className={styles.aBanner} style={{ marginTop: "10px" }}>
                <div className={styles.aBannerTop}>
                  <div className={styles.aTopItem}>
                    <div className={styles.aTopName}>{"Active Users"}</div>
                    <div className={styles.aTopValue}>{users ? users.length : "..."}</div>
                  </div>
                  <div className={styles.aTopItem}>
                    <div className={styles.aTopName}>{"Total Interactions"}</div>
                    <div className={styles.aTopValue}>{totalInteractions}</div>
                  </div>
                  <div className={styles.aTopItem}>
                    <div className={styles.aTopName}>{"Total Feedback Given"}</div>
                    <div className={styles.aTopValue}>{posCount + negCount}</div>
                  </div>
                  <div className={styles.aTopItem}>
                    <div className={styles.aTopName}>{"Positive"}</div>
                    <div className={styles.aTopValue}>
                      {negCount + posCount === 0 ? "..." : ((posCount * 100) / (negCount + posCount)).toFixed(2) + "%"}
                    </div>
                  </div>
                  <div className={styles.aTopItem}>
                    <div className={styles.aTopName}>{"Negative"}</div>
                    <div className={styles.aTopValue}>
                      {negCount + posCount === 0 ? "..." : ((negCount * 100) / (negCount + posCount)).toFixed(2) + "%"}
                    </div>
                  </div>
                </div>
                <div className={styles.aBannerBot}>
                  <div className={styles.wordCloudHolder}>
                    <div className={styles.chartTitle}>{"Positive Feedback: Common Terms"}</div>
                    {this.renderWordCloud()}
                  </div>
                  <div className={styles.wordCloudHolder}>
                    <div className={styles.chartTitle}>{"Negative Feedback: Common Terms"}</div>
                    {this.renderWordCloud(true)}
                  </div>
                  {this.renderFeedbackPieChart()}
                </div>
              </div>
              {this.renderWordFeedbackCount()}
              {this.renderPromptWarnings()}
            </div>
          ) : chat_type === "ACTIVITY_MONITORING" ? (
            this.renderActivityMonitoring()
          ) : chat_type === "FEEDBACK_ANALYTICS" ? (
            this.renderFeedbackAnalytics()
          ) : chat_type === "ANOMALY_ALERTS" ? (
            this.renderAnomalyAlerts()
          ) : chat_type === "CACHED_PROMPTS" ? (
            this.renderCachedPrompts()
          ) : (
            <div />
          )}
          <div className={styles.aBot}>
            <div className={styles.fewShotDownload}>
              <Button
                onClick={() => {
                  let fewShotExamples = [];
                  reports &&
                    reports
                      .filter((r) => r?.metadata?.explorations?.[0]?.fewShotExamples !== undefined)
                      .forEach((r) => {
                        Object.keys(r.metadata.explorations[0].fewShotExamples).forEach((fKey) => {
                          fewShotExamples.push(r.metadata.explorations[0].fewShotExamples[fKey]);
                        });
                      });

                  const file = new File([JSON.stringify(fewShotExamples)], "few-shot-dataset.txt", {
                    type: "text/plain"
                  });

                  const link = document.createElement("a");
                  const url = URL.createObjectURL(file);

                  link.href = url;
                  link.download = file.name;
                  document.body.appendChild(link);
                  link.click();

                  document.body.removeChild(link);
                  window.URL.revokeObjectURL(url);
                }}
                style={{ padding: "3px", marginRight: "20px" }}
              >
                <img src={downloadFeedbackIcon} style={{ height: "18px", marginRight: "3px" }} />
                {"Download Feedback"}
                <Tooltip
                  overlay={"Download all few-shot feedback within your organization to use in fine-tuning your LLM."}
                />
              </Button>
            </div>
            {chat_type === "OVERVIEW" && (
              <div className={styles.topTitle} style={{ marginBottom: "5px", fontSize: "18px" }}>
                {"Top Agent Templates"}
              </div>
            )}
            {chat_type === "ACTIVITY_MONITORING"
              ? this.renderUseCaseTable_Activity()
              : chat_type === "FEEDBACK_ANALYTICS"
                ? this.renderUseCaseTable_Feedback()
                : chat_type === "ANOMALY_ALERTS"
                  ? this.renderUseCaseTable_Anomaly()
                  : chat_type === "CACHED_PROMPTS"
                    ? this.renderUseCaseTable_Cached()
                    : this.renderUseCaseTable()}
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderActivityMonitoring() {
    return (
      <div className={styles.feedbackAnalytics}>
        <div className={styles.tileChart} style={{ width: "max(365px, calc(20% - 10px))" }}>
          {this.renderMonthlyInteractions()}
        </div>
        <div className={styles.tileChart} style={{ width: "max(365px, calc(20% - 10px))" }}>
          {this.renderAbandonedInteractions()}
        </div>
        <div className={styles.tileChart} style={{ width: "max(365px, calc(20% - 10px))" }}>
          {this.renderStructuredDatasets()}
        </div>
        <div className={styles.tileChart} style={{ width: "max(365px, calc(20% - 10px))" }}>
          {this.renderDocumentsAdded()}
        </div>
        <div className={styles.tileChart} style={{ width: "max(365px, calc(20% - 10px))" }}>
          {this.renderActiveUsersPerWeek()}
        </div>
      </div>
    );
  }

  renderMonthlyInteractions() {
    const { allChats } = this.props;

    const lastSixMonths = Array.from({ length: 6 }).map((_, i) =>
      moment()
        .subtract(i, "month" + "s")
        .startOf("month")
        .toDate()
    );

    const counts = lastSixMonths
      .map((date) => {
        const endOfMonth = moment(date).endOf("month").toDate();
        const monthCount = allChats.filter(
          (item) => new Date(item.date) >= date && new Date(item.date) <= endOfMonth
        ).length;

        return {
          name: moment(date).format("MMM YYYY"),
          count: monthCount,
          percent: (monthCount / allChats.length) * 100
        };
      })
      .reverse();

    return (
      <div className={styles.nChartHolder}>
        <div className={styles.nChartTitle}>{"Monthly Interactions"}</div>
        <div className={styles.nChart}>
          <SimpleBarChart data={counts} nameKey="name" otherKey="percent" isCount />
        </div>
      </div>
    );
  }

  renderAbandonedInteractions() {
    const { allChats } = this.props;

    let chats_by_report = {};

    allChats.forEach((a) => {
      if (chats_by_report[a?.reportId] === undefined) {
        chats_by_report[a?.reportId] = [];
      }

      chats_by_report[a?.reportId].push(a);
    });

    const aChats = [];

    Object.keys(chats_by_report).forEach((cKey) => {
      if (chats_by_report[cKey].filter((c) => c.user === "User").length === 1) {
        aChats.push(chats_by_report[cKey].filter((c) => c.user === "User")?.[0]);
      }
    });

    const lastSixMonths = Array.from({ length: 6 }).map((_, i) =>
      moment()
        .subtract(i, "month" + "s")
        .startOf("month")
        .toDate()
    );
    const counts = lastSixMonths
      .map((date) => {
        const endOfMonth = moment(date).endOf("month").toDate();

        const monthCount = aChats.filter(
          (item) => new Date(item.date) >= date && new Date(item.date) <= endOfMonth
        ).length;

        return {
          name: moment(date).format("MMM YYYY"),
          count: aChats.filter((item) => new Date(item.date) >= date && new Date(item.date) <= endOfMonth).length,
          percent: (monthCount / allChats.length) * 100
        };
      })
      .reverse();

    return (
      <div className={styles.nChartHolder}>
        <div className={styles.nChartTitle}>{"Abandoned Interactions & Chats"}</div>
        <div className={styles.nChart}>
          <SimpleBarChart data={counts} nameKey="name" otherKey={"percent"} isCount />
        </div>
      </div>
    );
  }

  renderStructuredDatasets() {
    const { datasets } = this.props;

    const retData = {};

    datasets &&
      datasets.forEach((d) => {
        if (retData[d.created_by.fullname] === undefined) {
          retData[d.created_by.fullname] = 0;
        }

        retData[d.created_by.fullname] += 1;
      });

    return (
      <div className={styles.nChartHolder}>
        <div className={styles.nChartTitle}>{"Structured Datasets Added"}</div>
        <div className={styles.nChart}>
          <SimplePieChart
            useColorsTwo
            data={Object.keys(retData).map((d) => ({
              name: d,
              value: retData[d]
            }))}
          />
        </div>
      </div>
    );
  }

  renderDocumentsAdded() {
    const { corpusList } = this.props;

    const retData = {};

    corpusList &&
      corpusList.forEach((d) => {
        if (retData[d.created_by.fullname] === undefined) {
          retData[d.created_by.fullname] = 0;
        }

        retData[d.created_by.fullname] += 1;
      });

    return (
      <div className={styles.nChartHolder}>
        <div className={styles.nChartTitle}>{"Documents Added"}</div>
        <div className={styles.nChart}>
          <SimplePieChart
            useColorsTwo
            data={Object.keys(retData).map((d) => ({
              name: d === "RAW_DATA" ? "CSV Upload" : d,
              value: retData[d]
            }))}
          />
        </div>
      </div>
    );
  }

  renderActiveUsersPerWeek() {
    const { allChats } = this.props;

    return (
      <div className={styles.nChartHolder}>
        <div className={styles.nChartTitle}>{"Active Users Per Week"}</div>
        <div className={styles.nChart}>
          <SimpleLineChart data={allChats.map((a, i) => ({ date: a.date, index: i }))} date_type="week" width={350} />
        </div>
      </div>
    );
  }

  getUserFeedbackCounts() {
    const { allChats } = this.props;

    const userFeedbackCounts = {};
    allChats &&
      allChats.forEach((chat) => {
        const chatUser = chat?.analytics?.user ?? "Aible Test";

        if (userFeedbackCounts[chatUser] === undefined) {
          userFeedbackCounts[chatUser] = { like: 0, dislike: 0 };
        }

        if (chat?.feedback?.THUMBS_UP.length > 0) {
          userFeedbackCounts[chatUser].like += 1;
        } else if (chat?.feedback?.THUMBS_DOWN.length > 0) {
          userFeedbackCounts[chatUser].dislike += 1;
        }
      });

    return userFeedbackCounts;
  }

  getAllFeedbackCounts() {
    const { allChats } = this.props;

    const retCounts = { models: {}, useCase: {} };
    allChats &&
      allChats.forEach((chat) => {
        if (chat?.analytics?.modelId !== undefined) {
          if (retCounts.models[chat?.analytics?.modelId] === undefined) {
            retCounts.models[chat?.analytics?.modelId] = {
              like: 0,
              dislike: 0
            };
          }

          if (chat?.feedback?.THUMBS_UP.length > 0) {
            retCounts.models[chat?.analytics?.modelId].like += 1;
          } else if (chat?.feedback?.THUMBS_DOWN.length > 0) {
            retCounts.models[chat?.analytics?.modelId].dislike += 1;
          }
        }

        if (chat?.analytics?.blueprintId !== undefined) {
          if (retCounts.useCase[chat?.analytics?.blueprintId] === undefined) {
            retCounts.useCase[chat?.analytics?.blueprintId] = {
              like: 0,
              dislike: 0
            };
          }

          if (chat?.feedback?.THUMBS_UP.length > 0) {
            retCounts.useCase[chat?.analytics?.blueprintId].like += 1;
          } else if (chat?.feedback?.THUMBS_DOWN.length > 0) {
            retCounts.useCase[chat?.analytics?.blueprintId].dislike += 1;
          }
        }
      });

    return retCounts;
  }

  getUseCaseName(useCaseId) {
    const { chatBlueprints } = this.props;
    return chatBlueprints.find((b) => b.id === useCaseId) !== undefined
      ? chatBlueprints.find((b) => b.id === useCaseId)?.name
      : (chatGPTReducer?.CHATAIBLE_BLUEPRINTS?.[useCaseId]?.name ??
          (useCaseId === chatGPTReducer?.CHATAIBLE_DOCUMENT_SUMMARIZATION?.id
            ? chatGPTReducer?.CHATAIBLE_DOCUMENT_SUMMARIZATION?.name
            : useCaseId === chatGPTReducer?.CHATAIBLE_SQL?.id
              ? chatGPTReducer?.CHATAIBLE_SQL?.name
              : useCaseId === chatGPTReducer?.CHATAIBLE_WHATS_CHANGED?.id
                ? chatGPTReducer?.CHATAIBLE_WHATS_CHANGED?.name
                : useCaseId));
  }

  renderFeedbackAnalytics() {
    const { modelOptions } = this.props;

    const fCounts = this.getAllFeedbackCounts();

    const modelData = Object.keys(fCounts.models).map((m) => ({
      model: modelOptions.find((o) => o.value === m)?.label ?? m,
      positive: fCounts.models[m].like,
      negative: fCounts.models[m].dislike
    }));

    const useCaseData = Object.keys(fCounts.useCase)
      .map((c) => ({
        use_case: this.getUseCaseName(c),
        positive: fCounts.useCase[c].like,
        negative: fCounts.useCase[c].dislike
      }))
      .filter((u) => u.negative > 0 || u.positive > 0);

    return (
      <div className={styles.feedbackAnalytics}>
        <div
          className={styles.tileChart}
          style={{
            width: "max(463px, calc(25% - 10px))"
          }}
        >
          {this.renderTotalFeedback()}
        </div>
        <div
          className={styles.tileChart}
          style={{
            width: "max(463px, calc(25% - 10px))"
          }}
        >
          {this.renderFeedbackPieChartAnalytics()}
        </div>
        <div
          className={styles.tileChart}
          style={{
            width: "max(463px, calc(25% - 10px))"
          }}
        >
          <div className={styles.feedbackPieAnalytics}>
            <div className={styles.nChartTitle}>{"Feedback By Model"}</div>
            <div className={styles.nChart}>
              <SimpleBarChart data={modelData} nameKey={"model"} />
            </div>
          </div>
        </div>
        <div
          className={styles.tileChart}
          style={{
            width: "max(463px, calc(25% - 10px))"
          }}
        >
          <div className={styles.feedbackPieAnalytics}>
            <div className={styles.nChartTitle}>{"Feedback By Agent Templates"}</div>
            <div className={styles.nChart}>
              <SimpleBarChart data={useCaseData} nameKey={"use_case"} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderTotalFeedback() {
    const { allChats } = this.props;

    const allFeedbacks = allChats
      .filter((a) => a.feedback?.THUMBS_UP?.length > 0 || a.feedback?.THUMBS_DOWN?.length > 0)
      .map((a, i) => ({ date: a.date, index: i }));

    return (
      <div className={styles.feedbackPieAnalytics}>
        <div className={styles.nChartTitle}>{"Total Feedback"}</div>
        <div className={styles.nChart}>
          <SimpleLineChart data={allFeedbacks} />
        </div>
      </div>
    );
  }

  getAnomaliesByUser() {
    const { allChats } = this.props;

    const anomalies = allChats ? allChats.filter((c) => c.isAnomaly === true) : [];

    let anomalies_users = {};

    anomalies.forEach((a) => {
      if (anomalies_users[a?.analytics?.user] === undefined) {
        anomalies_users[a?.analytics?.user] = [];
      }

      anomalies_users[a?.analytics?.user].push(a);
    });

    return anomalies_users;
  }

  getCachedByUser() {
    const { allChats } = this.props;

    const retChats = allChats ? allChats.filter((c) => c.isCachedResponse === true) : [];

    let ret_users = {};

    retChats.forEach((a) => {
      if (ret_users[a?.analytics?.user] === undefined) {
        ret_users[a?.analytics?.user] = [];
      }

      ret_users[a?.analytics?.user].push(a);
    });

    return ret_users;
  }

  renderCachedPrompts() {
    const cached_users = this.getCachedByUser();

    let pDatasets = {};
    let pReports = {};
    Object.keys(cached_users).forEach((c) => {
      cached_users[c].forEach((cm) => {
        if (cm.datasetId !== undefined) {
          pDatasets[cm.datasetId] = true;
        }
        if (cm?.reportId !== undefined) {
          pReports[cm?.reportId] = true;
        }
      });
    });

    return (
      <div className={styles.actInfo}>
        <div className={styles.aTopItem}>
          <div className={styles.aTopName}>{"Total Cached Prompts"}</div>
          <div className={styles.aTopValue}>
            {Object.keys(cached_users).reduce((a, b) => a + cached_users[b].length, 0)}
          </div>
        </div>
        <div className={styles.aTopItem}>
          <div className={styles.aTopName}>{"Users"}</div>
          <div className={styles.aTopValue}>{Object.keys(cached_users)?.length}</div>
        </div>
        <div className={styles.aTopItem}>
          <div className={styles.aTopName}>{"Total Datasets"}</div>
          <div className={styles.aTopValue}>{Object.keys(pDatasets).length}</div>
        </div>
        <div className={styles.aTopItem}>
          <div className={styles.aTopName}>{"Total Reports"}</div>
          <div className={styles.aTopValue}>{Object.keys(pReports).length}</div>
        </div>
      </div>
    );
  }

  renderAnomalyAlerts() {
    const { allChats } = this.props;

    const anomalies = allChats ? allChats.filter((c) => c.isAnomaly === true) : [];

    const anomalies_last30 = anomalies.filter((d) => moment(d.date).isAfter(moment().subtract(1, "months")));

    const anomalies_users = this.getAnomaliesByUser();

    const aOptions = [
      {
        label: "Anomalies Last 30 Days",
        value: "Anomalies Last 30 Days"
      }
    ];

    return (
      <div className={styles.actInfo}>
        <div className={styles.anomSelector}>
          <Select options={aOptions} value={aOptions?.[0]} />
        </div>
        <div className={styles.aTopItem}>
          <div className={styles.aTopName}>{"Total Alerts"}</div>
          <div className={styles.aTopValue}>{anomalies.length}</div>
        </div>
        <div className={styles.aTopItem}>
          <div className={styles.aTopName}>{"Trend vs Last 30 days"}</div>
          <div className={styles.aTopValue}>{anomalies_last30.length}</div>
        </div>
        <div className={styles.aTopItem}>
          <div className={styles.aTopName}>{"Users Flagged"}</div>
          <div className={styles.aTopValue}>{Object.keys(anomalies_users)?.length}</div>
        </div>
      </div>
    );
  }

  getColumnChats() {
    const { allChats } = this.props;

    const columnChats = {};
    allChats &&
      allChats.forEach((chat) => {
        if (chat?.analytics?.blueprintId !== undefined && chat?.analytics?.blueprintId !== "ASK_FOR_DATASET") {
          if (columnChats[chat?.analytics?.blueprintId] === undefined) {
            columnChats[chat?.analytics?.blueprintId] = [];
          }

          columnChats[chat?.analytics?.blueprintId].push(chat);
        }
      });

    return columnChats;
  }

  renderUseCaseTable_Feedback() {
    const { reports } = this.props;

    const { feedback_type } = this.state;

    const reportsWithCounts = reports.map((report) => {
      let likes = 0;
      let dislikes = 0;

      if (report?.metadata?.chatGPTConvo?.conversation !== undefined) {
        const conversation = Object.keys(report?.metadata?.chatGPTConvo?.conversation) ?? [];

        const lastMessage = report?.metadata?.chatGPTConvo?.conversation?.[conversation?.length - 1];
        const lastResponse = lastMessage?.text ?? lastMessage?.userText ?? "Could not find the response";
        const lastQuestion =
          report?.metadata?.chatGPTConvo?.conversation?.[lastMessage?.questionIndex]?.userText ??
          "Could not find the question";

        conversation.forEach((index) => {
          const message = report?.metadata?.chatGPTConvo?.conversation[index];
          if (message?.feedback?.THUMBS_UP.length > 0) {
            likes += 1;
          }
          if (message?.feedback?.THUMBS_DOWN.length > 0) {
            dislikes += 1;
          }
        });

        return {
          ...report,
          likes: likes,
          dislikes: dislikes,
          lastQuestion: lastQuestion,
          lastResponse: lastResponse
        };
      }
    });

    let reportsWithFeedback = reportsWithCounts.filter((report) => report?.likes > 0 || report?.dislikes > 0);
    if (feedback_type === "ALL") {
      reportsWithFeedback = reportsWithCounts.filter((report) => report?.likes > 0 || report?.dislikes > 0);
    } else if (feedback_type === "POSITIVE") {
      reportsWithFeedback = reportsWithCounts.filter((report) => report?.likes > 0);
    } else if (feedback_type === "NEGATIVE") {
      reportsWithFeedback = reportsWithCounts.filter((report) => report?.dislikes > 0);
    }

    return (
      <div className={styles.useCaseTable}>
        <div className={styles.uHeaderButtonRow}>
          <div className={styles.uHeaderButtonTitle}>{"Chat Feedback"}</div>
          <ButtonGroup>
            <Button
              onClick={() => {
                this.setState({ feedback_type: "ALL" });
              }}
              active={feedback_type === "ALL"}
            >
              {"All"}
            </Button>
            <Button
              onClick={() => {
                this.setState({ feedback_type: "POSITIVE" });
              }}
              active={feedback_type === "POSITIVE"}
            >
              {"Positive"}
            </Button>
            <Button
              onClick={() => {
                this.setState({ feedback_type: "NEGATIVE" });
              }}
              active={feedback_type === "NEGATIVE"}
            >
              {"Negative"}
            </Button>
          </ButtonGroup>
        </div>
        <div className={styles.uHeaderRow}>
          <div className={styles.uHeaderItem}>{"Project"}</div>
          <div className={styles.uHeaderItem}>{"Project Owner"}</div>
          <div className={styles.uHeaderItem}>{"Feedback"}</div>
          <div className={styles.uHeaderItem}>{"Prompt"}</div>
          <div className={styles.uHeaderItem}>{"Response"}</div>
          <div className={styles.uHeaderItemLink}>{"Link to Project"}</div>
        </div>
        <div className={styles.reversedRowContainer}>
          {reportsWithFeedback.map((report, index) => (
            <div className={styles.uRow} style={index === 0 ? { borderBottom: "none" } : {}}>
              <div className={styles.uItem}>{`${report?.id} ${report?.name}`}</div>
              <div className={styles.uItem}>{report?.created_by?.fullname}</div>
              <div className={styles.uItem}>{`${report?.likes} Positive ${report?.dislikes} Negative`}</div>
              <div className={styles.uItem}>{report?.lastQuestion}</div>
              <div className={styles.uItem}>{report?.lastResponse}</div>
              <div className={styles.uItemLink}>
                <Button
                  onClick={() => {
                    if (report?.metadata?.chatGPTConvo?.datasetId) {
                      const datasetId = report?.metadata?.chatGPTConvo?.datasetId;
                      this.props.history.push(`/next/${datasetId}/${report?.id}`);
                    } else {
                      this.props.history.push(`/next/new/${report?.id}`);
                    }
                  }}
                >
                  {"Open Project"}
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderUseCaseTable_Cached() {
    const { datasets } = this.props;

    const cached_users = this.getCachedByUser();
    let u_promps = {};
    Object.keys(cached_users).forEach((u) =>
      cached_users[u].forEach((cm) => {
        if (u_promps[cm?.oUserPrompt] === undefined) {
          u_promps[cm?.oUserPrompt] = [];
        }

        u_promps[cm?.oUserPrompt].push(cm);
      })
    );

    return (
      <div className={styles.useCaseTable}>
        <div className={styles.uHeaderRow}>
          <div className={styles.uHeaderItem}>{"User"}</div>
          <div className={styles.uHeaderItem}>{"Prompt"}</div>
          <div className={styles.uHeaderItem}>{"Cached Times"}</div>
          <div className={styles.uHeaderItem}>{"Agent Templates"}</div>
          <div className={styles.uHeaderItem}>{"Datasets"}</div>
        </div>
        {Object.keys(u_promps).map((r, i) => {
          return (
            <div
              className={styles.uRow}
              style={i >= Object.keys(u_promps).length - 1 ? { borderBottom: "none" } : {}}
              onClick={() =>
                this.setState({
                  anomaly_modal: u_promps[r]
                })
              }
            >
              <div className={styles.uItem}>
                {[...new Set(u_promps[r].map((item) => item?.analytics?.user))].join(", ")}
              </div>
              <div className={styles.uItem}>{r}</div>
              <div className={styles.uItem}>{u_promps[r].length}</div>
              <div className={styles.uItem}>
                {[...new Set(u_promps[r].map((item) => this.getUseCaseName(item?.analytics?.blueprintId)))].join(", ")}
              </div>
              <div className={styles.uItem}>
                {[
                  ...new Set(
                    u_promps[r]
                      .map((item) => datasets.find((d) => d.id == item?.datasetId)?.label)
                      .filter((item) => item !== undefined)
                  )
                ].join(", ")}
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  renderUseCaseTable_Anomaly() {
    const anomalies_users = this.getAnomaliesByUser();

    return (
      <div className={styles.useCaseTable}>
        <div className={styles.uHeaderRow}>
          <div className={styles.uHeaderItem}>{"User"}</div>
          <div className={styles.uHeaderItem}>{"Total Prompts"}</div>
          <div className={styles.uHeaderItem}>{"Agent Templates"}</div>
          <div className={styles.uHeaderItem}>{"Datasets"}</div>
        </div>
        {Object.keys(anomalies_users).map((r, i) => {
          return (
            <div
              className={styles.uRow}
              style={i >= Object.keys(anomalies_users).length - 1 ? { borderBottom: "none" } : {}}
              onClick={() =>
                this.setState({
                  anomaly_modal: anomalies_users[r]
                })
              }
            >
              <div className={styles.uItem}>{anomalies_users[r]?.[0]?.analytics?.user}</div>
              <div className={styles.uItem}>{anomalies_users[r].length}</div>
              <div className={styles.uItem}>
                {[...new Set(anomalies_users[r].map((item) => this.getUseCaseName(item?.analytics?.blueprintId)))].join(
                  ", "
                )}
              </div>
              <div className={styles.uItem}>
                {[...new Set(anomalies_users[r].map((item) => item?.analytics?.datasetId))].join(", ")}
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  renderUseCaseTable_Activity() {
    const { allChats, users, datasets } = this.props;

    const rows = users
      .filter((u) => u.fullname !== undefined && u.fullname !== "")
      .map((u) => {
        const userChats = allChats
          .filter((a) => (a?.analytics?.user ?? "Aible Test") === u.fullname)
          .sort((a, b) => (moment(a.date).isAfter(b.date) ? 1 : -1));

        let chats_by_report = {};

        userChats.forEach((a) => {
          if (chats_by_report[a?.reportId] === undefined) {
            chats_by_report[a?.reportId] = [];
          }

          chats_by_report[a?.reportId].push(a);
        });

        return {
          name: u.fullname,
          monthly: userChats.filter((d) => moment(d.date).isAfter(moment().subtract(1, "months"))).length,
          abandonded: Object.keys(chats_by_report).filter(
            (rKey) => chats_by_report[rKey].filter((c) => c.user === "User")?.length === 1
          ).length,
          datasetsAdded: datasets.filter((d) => d.created_by.fullname === u.fullname).length,
          chatsPerWeek:
            userChats.length > 1 && moment().diff(moment(userChats[0].date), "weeks") !== 0
              ? userChats.length / moment().diff(moment(userChats[0].date), "weeks")
              : userChats.length
        };
      })
      .sort((a, b) => (a.monthly < b.monthly ? 1 : a.monthly > b.monthly ? -1 : 0));

    return (
      <div className={styles.useCaseTable}>
        <div className={styles.uHeaderRow}>
          <div className={styles.uHeaderItem}>{"User"}</div>
          <div className={styles.uHeaderItem}>{"Monthly Interactions"}</div>
          <div className={styles.uHeaderItem}>{"Abandoned Interactions"}</div>
          <div className={styles.uHeaderItem}>{"Structured Datasets Added"}</div>
          <div className={styles.uHeaderItem}>{"Chats Per Week"}</div>
        </div>
        {rows.map((r, i) => (
          <div className={styles.uRow} style={i >= rows.length - 1 ? { borderBottom: "none" } : {}}>
            <div className={styles.uItem}>{r?.name}</div>
            <div className={styles.uItem}>{r.monthly}</div>
            <div className={styles.uItem}>{r.abandonded}</div>
            <div className={styles.uItem}>{r.datasetsAdded}</div>
            <div className={styles.uItem}>{r.chatsPerWeek}</div>
          </div>
        ))}
      </div>
    );
  }

  renderUseCaseTable() {
    const { modelOptions } = this.props;

    const columnChats = this.getColumnChats();

    let fCounts = {};
    columnChats &&
      Object.keys(columnChats).map((c, i) => {
        fCounts[c] = {
          positive_count: columnChats[c].reduce((a, b) => a + (b.feedback?.THUMBS_UP?.length ?? 0), 0),
          negative_count: columnChats[c].reduce((a, b) => a + (b.feedback?.THUMBS_DOWN?.length ?? 0), 0)
        };
      });

    const rows = Object.keys(columnChats)
      .sort((a, b) => columnChats[b].length - columnChats[a].length)
      .map((c) => ({
        ...columnChats[c],
        topic: c === "" ? "None (General Question)" : c,
        totalInteractions: columnChats[c].length,
        positive_count: fCounts[c].positive_count,
        negative_count: fCounts[c].negative_count,
        useCase: "Chat Analytics",
        model: columnChats[c].find((chat) => chat?.model !== undefined)?.model,
        dataSources: "GCP"
      }));

    return (
      <div className={styles.useCaseTable}>
        <div className={styles.uHeaderRow}>
          <div className={styles.uHeaderItem}>{"Agent Templates"}</div>
          <div className={styles.uHeaderItem}>{"Total Interactions"}</div>
          <div className={styles.uHeaderItem}>{"Total Feedback"}</div>
          <div className={styles.uHeaderItem}>{"Model"}</div>
          <div className={styles.uHeaderItem}>{"Data Sources"}</div>
        </div>
        {rows.map((r, i) => (
          <div className={styles.uRow} style={i >= rows.length - 1 ? { borderBottom: "none" } : {}}>
            <div className={styles.uItem}>{this.getUseCaseName(r.topic)}</div>
            <div className={styles.uItem}>{r.totalInteractions}</div>
            <div className={styles.uItem}>{this.renderPositiveNegativeBars(r.positive_count, r.negative_count)}</div>
            <div className={styles.uItem}>{modelOptions.find((o) => o?.value === r?.model)?.label}</div>
            <div className={styles.uItem}>{r.dataSources}</div>
          </div>
        ))}
      </div>
    );
  }

  renderPositiveNegativeBars(posCount, negCount) {
    return (
      <div className={styles.posNegBars}>
        <div className={styles.fCount} style={{ width: "10%" }}>
          {posCount + negCount}
        </div>
        <div
          className={styles.positiveBar}
          style={{
            width: posCount + negCount === 0 ? "0%" : (posCount * 90) / (posCount + negCount) + "%"
          }}
        />
        <div
          className={styles.negativeBar}
          style={{
            width: posCount + negCount === 0 ? "0%" : (negCount * 90) / (posCount + negCount) + "%",
            border: negCount === 0 ? "none" : "2px solid #961715"
          }}
        />
      </div>
    );
  }

  renderFeedbackPieChartAnalytics() {
    const { allChats } = this.props;

    const likeCount = allChats.reduce((a, b) => a + (b?.feedback?.THUMBS_UP?.length > 0 ? 1 : 0), 0);
    const dislikeCount = Math.abs(allChats.reduce((a, b) => a + (b?.feedback?.THUMBS_DOWN?.length > 0 ? -1 : 0), 0));

    const feedbackCounts = [
      { name: "Like", value: likeCount },
      { name: "Dislike", value: dislikeCount }
    ];

    return (
      <div className={styles.feedbackPieAnalytics}>
        <div className={styles.nChartTitle}>{"Feedback Split"}</div>
        <div className={styles.nChart}>
          <SimplePieChart data={feedbackCounts} />
        </div>
      </div>
    );
  }

  renderFeedbackPieChart() {
    const { allChats } = this.props;

    const likeCount = allChats.reduce((a, b) => a + (b?.feedback?.THUMBS_UP?.length > 0 ? 1 : 0), 0);
    const dislikeCount = Math.abs(allChats.reduce((a, b) => a + (b?.feedback?.THUMBS_DOWN?.length > 0 ? -1 : 0), 0));

    const feedbackCounts = [
      { name: "Like", value: likeCount },
      { name: "Dislike", value: dislikeCount }
    ];

    return (
      <div className={styles.feedbackPie}>
        <div className={styles.chartTitle}>{"Feedback Mix"}</div>
        <div className={styles.feedbackPieChart}>
          <SimplePieChart data={feedbackCounts} />
        </div>
      </div>
    );
  }

  filterCommonWords(inputString) {
    // List of common words
    const commonWords = [
      "a",
      "the",
      "that",
      "with",
      "about",
      "above",
      "after",
      "again",
      "against",
      "all",
      "am",
      "an",
      "and",
      "any",
      "are",
      "aren't",
      "as",
      "at",
      "be",
      "because",
      "been",
      "before",
      "being",
      "below",
      "between",
      "both",
      "but",
      "by",
      "can't",
      "cannot",
      "could",
      "chart_id",
      "couldn't",
      "did",
      "didn't",
      "do",
      "does",
      "doesn't",
      "doing",
      "don't",
      "down",
      "during",
      "each",
      "few",
      "for",
      "from",
      "further",
      "had",
      "hadn't",
      "has",
      "hasn't",
      "have",
      "haven't",
      "having",
      "he",
      "he'd",
      "he'll",
      "he's",
      "her",
      "here",
      "here's",
      "hers",
      "herself",
      "him",
      "himself",
      "his",
      "how",
      "how's",
      "i",
      "i'd",
      "i'll",
      "i'm",
      "i've",
      "if",
      "in",
      "into",
      "is",
      "isn't",
      "it",
      "it's",
      "its",
      "itself",
      "let's",
      "me",
      "more",
      "most",
      "mustn't",
      "my",
      "myself",
      "no",
      "nor",
      "not",
      "of",
      "off",
      "on",
      "once",
      "only",
      "or",
      "other",
      "ought",
      "our",
      "ours",
      "ourselves",
      "out",
      "the",
      "this",
      "they",
      "which",
      "with",
      ",",
      "etc",
      ";",
      ":",
      ".",
      ";",
      "**",
      "&",
      "; ",
      ": ",
      ", ",
      ";",
      ":",
      ",",
      '"',
      "\\",
      "*",
      "'",
      "[",
      "]",
      "{",
      "}",
      "<",
      ">",
      "-",
      ". ",
      "."
    ];

    // Split the input string into words, filter them and join them back
    return inputString
      .split(" ")
      .filter((word) => !commonWords.includes(word.toLowerCase()))
      .join(" ");
  }

  renderWordCloud(isNegative = false) {
    const { allChats, users } = this.props;

    const fChats = allChats.filter(
      (a) =>
        (a?.feedback?.THUMBS_UP?.length > 0 && isNegative !== true) ||
        (a?.feedback?.THUMBS_DOWN?.length > 0 && isNegative === true)
    );

    const allText = fChats.reduce((a, b) => a + (b.user === "User" ? (b?.userText ?? b.text) : b.text) + "\n", "");

    return (
      <div className={styles.wordCloudChart}>
        {/*<WordCloud data={this.countWordOccurrences(this.filterCommonWords(allText))} />*/}
      </div>
    );
  }

  render() {
    return (
      <div className={styles.artifactView}>
        {this.renderAnomalyModal()}
        {this.renderOverview()}
      </div>
    );
  }
}
